/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';
import WeeklyProgress from '../../components/WeeklyProgress';

export default function ProgressModule({
  userId, profile, startDate, theme, isAnalyzingStrategy, generateStrategyStudy, isSevenDayCycle,
  selectedDay, setShowManagePhotosModal, isDark, userPhotos, setUserPhotos,
  startCamera, fileInputRef, setCompareDay, setShowCompareModal,
  trackerWeight, setTrackerWeight, activeGuide, setActiveGuide,
  MEASUREMENT_GUIDES, trackerWaist, setTrackerWaist, trackerChest,
  setTrackerChest, trackerArm, setTrackerArm, handleSavePhysicalTracking,
  selectedMetric, setSelectedMetric, bodyLogs, selectedAnalyticsEx,
  setSelectedAnalyticsEx, dbExercises, logs, workoutPlan, realDay
}) {
  return (
    <div className="space-y-8 animate-fadeIn pb-6">
      
      <WeeklyProgress userId={userId} profile={profile} startDate={startDate} legacyLogs={bodyLogs} legacyPhotos={userPhotos} theme={theme} />

      <div className={`${theme.card} border ${theme.border} rounded-[2.5rem] p-8 space-y-6 ${theme.shadow} transition-colors duration-500`}>
        <div className={`flex justify-between items-center border-b ${theme.border} pb-4`}>
          <span className={`text-[10px] ${theme.muted} font-bold tracking-widest block uppercase`}>Progreso de Fuerza</span>
          <span className={`text-[10px] text-emerald-500 bg-emerald-500/10 border border-emerald-500/30 px-3 py-1 rounded-full font-bold tracking-widest`}>
            Historial Real
          </span>
        </div>
      
        <select value={selectedAnalyticsEx} onChange={(e) => setSelectedAnalyticsEx(e.target.value)} className={`w-full bg-transparent border-b ${theme.border} py-3 text-sm font-bold outline-none ${theme.text}`}>
          {Object.keys(dbExercises).map(key => (
            <option key={key} value={key} className={theme.card}>{dbExercises[key].name}</option>
          ))}
          {[...new Set(Object.keys(logs).map(k => k.split('_').slice(2).join('_')))]
            .filter(k => !dbExercises[k]) 
            .map(key => {
              let displayName = key;
              if (workoutPlan && workoutPlan.sessions) {
                for (const sessionKey in workoutPlan.sessions) {
                  const session = workoutPlan.sessions[sessionKey];
                  const foundEx = session.exercises?.find(ex => ex.id === key);
                  if (foundEx) { displayName = foundEx.name; break; }
                }
              }
              if (displayName === key) {
                 const relatedLogsKeys = Object.keys(logs).filter(k => k.endsWith(`_${key}`));
                 for (const lk of relatedLogsKeys) {
                     const entryWithName = logs[lk].find(e => e.name);
                     if (entryWithName) { displayName = entryWithName.name; break; }
                 }
              }
              if (displayName === key) {
                 if (key.startsWith('alt_')) displayName = 'Alternativa Personalizada';
                 else if (key.startsWith('p') || key.startsWith('t')) displayName = 'Ejercicio Personalizado';
              }
              return (
                <option key={key} value={key} className={theme.card}>
                  {displayName}
                </option>
              );
            })}
        </select>

        <div className={`h-32 ${theme.secondary} rounded-[2rem] border ${theme.border} p-4 flex items-end justify-between gap-3`}>
          {(() => {
            const historyData = [];
              for (let d = 1; d <= realDay; d++) {
                const dayLogs = logs[`day_${d}_${selectedAnalyticsEx}`];
                if (dayLogs && dayLogs.length > 0) {
                  const maxWeight = Math.max(...dayLogs.map(l => l.weight));
                  historyData.push({ day: d, weight: maxWeight });
                }
              }

              if (historyData.length === 0) return <p className={`w-full text-center text-xs ${theme.muted} font-bold uppercase tracking-widest my-auto`}>Sin registros</p>;

              return historyData.map((entry, idx) => {
                const maxVal = Math.max(...historyData.map(h => h.weight), 1);
                const heightPct = Math.max((entry.weight / maxVal) * 100, 5); 
                return (
                  <div key={idx} className="flex-1 flex flex-col items-center gap-2 group relative">
                    <div className="h-full w-full flex items-end">
                      <div className={`w-full ${isDark ? 'bg-emerald-500/20 border-t border-emerald-500' : 'bg-emerald-200 border-t border-emerald-600'} group-hover:bg-emerald-500 rounded-t-md transition-all duration-500`} style={{ height: `${heightPct}%` }}>
                        <span className="absolute -top-6 left-1/2 -translate-x-1/2 text-[8px] font-bold text-white bg-black/80 px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity z-10">{entry.weight}kg</span>
                      </div>
                    </div>
                    <span className={`text-[8px] ${theme.muted} font-bold uppercase tracking-widest`}>D{entry.day}</span>
                  </div>
                );
              });
            })()}
          </div>
        </div>

    </div>
  );
}